import { Navigate, useSearchParams } from 'react-router-dom';

interface NavigateWithParamsProps {
  to: string;
  replace?: boolean;
  state?: any;
  paramsToPreserve?: string[];
  preserveAllParams?: boolean;
}

export function NavigateWithParams({
  to,
  replace = false,
  state,
  paramsToPreserve,
  preserveAllParams = false,
}: NavigateWithParamsProps) {
  const [searchParams] = useSearchParams();

  const trackingParams = new URLSearchParams();
  const defaultParamsToPreserve = ['__hstc', '__hssc', '__hsfp', '_gl'];

  const effectiveParamsToPreserve = preserveAllParams
    ? Array.from(searchParams.keys())
    : paramsToPreserve || defaultParamsToPreserve;

  effectiveParamsToPreserve.forEach((param) => {
    const paramValue = searchParams.get(param);
    if (paramValue !== null) {
      trackingParams.append(param, paramValue);
    }
  });

  const queryString = trackingParams.toString();
  const destinationPath = queryString ? `${to}?${queryString}` : to;

  return (
    <Navigate
      to={destinationPath}
      replace={replace}
      state={state}
    />
  );
}
